module.exports = __webpack_public_path__ + "969f2a22a34fbdafd5300926852891d1.mp4";